import $ from 'jquery';
import Swiper from 'swiper/swiper-bundle.min';
import { $window, MIN_DELAY } from '../variables/variables.js';
import { debounce } from '../functions/functions.js';

$( () => {
	if ( ! $( '.project' ).length ) {
		return;
	}

	/**
	 * Изменение ссылок на каталог работает только после событий scroll mousemove.
	 * Чтобы эти адреса не индексировались, так как содержат url параметры.
	 */
	let isChangeCatalogUrl = false;

	function changeCatalogUrl() {
		const $links = $( '.project__front-button, .project__popup-slider, .properties-slider__button' );

		$links.attr( 'href', $links.filter( '.project__front-button' ).attr( 'data-url' ) );
		$window.off( 'scroll mousemove', changeCatalogUrl );
		isChangeCatalogUrl = true;
		$( '.project__front-pic path.active' ).trigger( 'mouseenter' );
	}
	$window.on( 'scroll mousemove', changeCatalogUrl );

	// Переключение блоков
	( () => {
		const $tabs     = $( '.project__front-tab' );
		const $contents = $( '.project__front-content' );

		$tabs.on( 'click', function() {
			const $tab     = $( this );
			const $content = $contents.eq( $tab.index() );

			if ( $tab.hasClass( 'project__front-tab_active' ) ) {
				return;
			}

			$tabs.removeClass( 'project__front-tab_active' );
			$tab.addClass( 'project__front-tab_active' );
			$contents.removeClass( 'project__front-content_active project__front-content_animate' );
			$content.addClass( 'project__front-content_active' );

			setTimeout( () => {
				$content.addClass( 'project__front-content_animate' );
			}, MIN_DELAY );
		} );
	} )();

	// Переключение этажей
	$( '.project__front-pic > svg' ).each( function() {
		const $svg        = $( this );
		const $content    = $svg.closest( '.project__front-content' );
		const $floors     = $( 'path', $content );
		const $labels     = $( '.project__front-floor-label', $content )
		const $current    = $( '.counter__current', $content );
		const $title      = $( '.project__popup-title', $content );
		const $subtitle   = $( '.project__popup-subtitle', $content );
		const $frontLinks = $( '.project__front-button, .project__popup-slider', $content );

		function updateContent( swiper ) {
			let current = swiper.activeIndex + 1;

			if ( current < 10 ) {
				current = '0' + current;
			}

			const $label = $labels.eq( swiper.activeIndex );
			const title  = $label.text().split( ',' );

			// Установить заголовок попапа
			if ( ! $subtitle.data( 'text' ) ) {
				$subtitle.data( 'text', $subtitle.text() );
			}
			$title.text( title[0] );
			$current.text( current );

			if ( $( swiper.el ).is( ':visible' ) ) {
				$floors.eq( swiper.activeIndex ).trigger( 'changeFloor' );
			}

			if ( title[1] ) {
				$subtitle.text( $subtitle.data( 'text' ).replace( ')', ` / ${title[1]})` ) );
			} else {
				$subtitle.text( $subtitle.data( 'text' ) );
			}

			// Установить ссылки перехода в каталог для активной в кладки
			const FLOOR = $label.text().match( /^\d+/ );
			let   url   = $frontLinks.attr( 'href' ).replace( /&floor=.*/, '' );

			if ( FLOOR && FLOOR[0] ) {
				url += `&floor=${FLOOR[0]}`;
			}
			$frontLinks.attr( 'href', url );
		}

		const slider = new Swiper( $( '.project__popup-slider', $content )[0], {
			slidesPerView: 'auto',
			navigation: {
				nextEl: $( '.swiper-button-next', $content )[0],
				prevEl: $( '.swiper-button-prev', $content )[0],
			},
			on: {
				init:              updateContent,
				resize:            updateContent,
				activeIndexChange: updateContent,
			}
		} );

		// Изменить этаж
		$floors.on( 'mouseenter changeFloor', function( e ) {
			const $floor  = $( this );
			const $floors = $floor.parent().children( 'path' );
			const INDEX   = $floor.index();

			if ( ! $floor.hasClass( 'active' ) ) {
				$floors.removeClass( 'active' );
				$floor.addClass( 'active' );

				$labels.removeClass( 'project__front-floor-label_active' );
				$labels.eq( INDEX ).addClass( 'project__front-floor-label_active' );
			}

			if ( isChangeCatalogUrl && 'mouseenter' === e.type ) {
				slider.slideTo( $floor.index() );
			}
		} );
		$floors.eq( Math.round( Math.min( $floors.length, 16 ) / 2 ) ).trigger( 'mouseenter' );

		function setPositionLabels() {
			$floors.each( function() {
				const $floor         = $( this );
				const FLOOR_POSITION = $floor.offset();
				const PIC_POSITION   = $( this ).closest( '.project__front-pic' ).offset();
				const RECT           = $floor[0].getBoundingClientRect();

				$labels.eq( $floor.index() ).css( {
					top:  FLOOR_POSITION.top - PIC_POSITION.top + RECT.height / 2,
					left: FLOOR_POSITION.left - PIC_POSITION.left + RECT.width / 2,
				} );
			} );
		}
		setPositionLabels();
		$window.on( 'resizeWidth', debounce( setPositionLabels ) );
	} );

	// Инфраструктура
	( () => {
		const $units  = $( '.project__infrastructure-unit' );
		const $images = $( '.project__infrastructure-img' );

		$units.on( 'mouseenter', function() {
			const $unit = $( this );

			if ( $unit.hasClass( 'project__infrastructure-unit_active' ) ) {
				return;
			}

			$units.removeClass( 'project__infrastructure-unit_active' );
			$unit.addClass( 'project__infrastructure-unit_active' );
			$images.removeClass( 'project__infrastructure-img_active' );
			$images.eq( $unit.index() ).addClass( 'project__infrastructure-img_active' );
		} );

		function setHeightTexts() {
			$( '.project__infrastructure-text' ).each( function() {
				const $text     = $( this );
				const $unit     = $text.parent();
				const IS_ACTIVE = $unit.hasClass( 'project__infrastructure-unit_active' );

				if ( ! IS_ACTIVE ) {
					$unit.addClass( 'project__infrastructure-unit_active' )
				}

				$text.removeAttr( 'style' );
				setTimeout( () => {
					$text.css( 'max-height', $text.height() );

					if ( ! IS_ACTIVE ) {
						$unit.removeClass( 'project__infrastructure-unit_active' )
					}
				}, MIN_DELAY );
			} );
		}
		setHeightTexts();
		$window.on( 'resizeWidth', debounce( setHeightTexts ) );
	} )();
} );
